__turbopack_context__.v({
  "className": "inter_6e63d4e8-module__QTHNqG__className",
  "variable": "inter_6e63d4e8-module__QTHNqG__variable",
});
